"use client";

import AdDetailModel from "@/models/AdDetailModel";
import { Breadcrumbs, Typography } from "@mui/material";
import Link from "next/link";

export default function AdBreadcrumbs({ ad }: { ad: AdDetailModel }) {
  return (
    <Breadcrumbs
      sx={(theme) => ({
        ol: {
          flexWrap: "nowrap",
          li: {
            flexShrink: 0,
          },
        },
        [theme.breakpoints.down("md")]: {
          display: "none",
        },
      })}
    >
      <Link href="/for-sale/everything-equine">Everything Equine</Link>
      {ad.breadcrumbs.map((breadcrumb) => (
        <Link key={breadcrumb.url} href={breadcrumb.url}>
          {breadcrumb.label}
        </Link>
      ))}
      <Typography sx={{ fontSize: "inherit" }}>#{ad.id}</Typography>
    </Breadcrumbs>
  );
}
